import React from 'react';
import styled from 'styled-components';
import { spacer16, spacer24, spacer8, Type, } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, withAnimationContext, QuoteIcon, TWO_COLUMN_MAX_WIDTH, } from '../../../ui';
import { HeroLayout } from '../HeroLayout';
import { ResponsiveBodyType } from '../ResponsiveBodyType';
const Supertext = withAnimationContext(styled(Type.p).attrs({
    variant: 'balladBold',
}) `
    ${fadeInAnimation(DELAYS.FIRST)};
    text-transform: uppercase;
    margin-bottom: ${spacer24};
    @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
      margin-bottom: ${spacer16};
    }
  `);
const StyledQuoteIcon = styled(QuoteIcon) `
  margin-bottom: 10px;
`;
const Body = withAnimationContext(styled(ResponsiveBodyType) `
    ${fadeInAnimation(DELAYS.SECOND)};
  `);
const SourceAndTitle = styled.div `
  margin-top: ${spacer24};
  @media (max-width: ${TWO_COLUMN_MAX_WIDTH}) {
    margin-top: ${spacer16};
    display: ${({ noImage }) => (noImage ? 'block' : 'none')};
  }
`;
const Source = withAnimationContext(styled(Type.p).attrs({
    variant: 'canon',
}) `
    ${fadeInAnimation(DELAYS.THIRD)};
    margin-bottom: ${spacer8};
  `);
const JobTitle = withAnimationContext(styled(Type.p).attrs({
    variant: 'finaleBold',
}) `
    ${fadeInAnimation(DELAYS.FOURTH)};
    text-transform: uppercase;
  `);
export const HeroNarrativeQuoteModule = React.forwardRef(({ supertext, body = '', source = '', jobTitle = '', image, layout = 'imageRight', colors, }, ref) => {
    return (React.createElement(HeroLayout, { image: image, layout: layout, colors: colors, ref: ref },
        supertext && React.createElement(Supertext, null, supertext),
        React.createElement(StyledQuoteIcon, null),
        React.createElement(Body, { noImage: !image }, body),
        React.createElement(SourceAndTitle, { noImage: !image },
            React.createElement(Source, null,
                "\u2014",
                source),
            React.createElement(JobTitle, null, jobTitle))));
});
